import { DeliveryTypeEnum } from '../models';

export const DELIVERY_TYPE_LABELS: { [key in DeliveryTypeEnum]: string } = {
  [DeliveryTypeEnum.DELIVERY]: 'Delivery',
  [DeliveryTypeEnum.INSTORE]: 'Instore',
  [DeliveryTypeEnum.MAILBOX]: 'Mailbox',
  [DeliveryTypeEnum.PICKUP]: 'Pickup',
  [DeliveryTypeEnum.UNKNOWN]: 'Unknown',
};
